import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selectBusinessUsersListItems } from "../../../../../redux/business-users/selector";
import { businessUser } from "../../../../../redux/business-users/action";


const BusinessUsers = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
	const { header, footer, currency } = result
    const businessItems = useSelector(selectBusinessUsersListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'BusinessName', headerName: 'Business Name',searchField: 'BusinessName', filter: true,
            filterType: 'text' }, 
          { field: 'Email', headerName: 'Email',searchField: 'Email', filter: true,filterType: 'text'  },
          { field: 'PhoneNumber', headerName: 'Phone Number',searchField: 'PhoneNumber', filter: true,filterType: 'text' },
          { field: 'FirstName', headerName: 'First Name' ,searchField: 'FirstName', filter: true,filterType: 'text' },
          { field: 'LastName', headerName: 'Last Name',searchField: 'LastName', filter: true,filterType: 'text'  },
          { field: 'CreatedOnUtc', headerName: 'Created Date',isDateValueFormat:true },
          { field: 'ModifiedOnUtc', headerName: 'Modified Date', isDateValueFormat:true}
        ]);
      }
      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(businessUser.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/platform-management/business-users/list`,entity:'businessUser',jsonData:{
      
      
          "Records": [
            {
              "Context": {
              },
              "Message": {}
            }
          ],
          "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "Id",
                    "SortOrder": "desc",
                    "Searches": searchCriteria,
          }
          }}))
      }
    
      const handleSelect = (item: any, checked: any) => {
        console.log("Item", checked, item)
      }
    
      const handleSelectAll = (items: any[], checked: any) => {
        console.log("Items count", checked, items?.length)
        console.log('items', items)
      }

      const handleReloadData = () => {
        dispatch(businessUser.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/platform-management/business-users/list`,entity:'businessUser',jsonData:{
      
      
          "Records": [
            {
              "Context": {
              },
              "Message": {}
            }
          ],
          "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "Id",
                    "SortOrder": "desc",
                   
          }
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];
      const fetchBusiness=()=>{
        dispatch(businessUser.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/platform-management/business-users/list`,entity:'businessUser',jsonData:{
      
          "Records": [
            {
              "Context": {
              },
              "Message": {}
            }
          ],
          "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "Id",
                    "SortOrder": "desc",
                  
          }
    
        }}))
      }

	useEffect(() => {
        createColumnDefs()
        fetchBusiness()
	}, [pageData,pageSize])
    

      const handleDelete=(data: any)=>{
        dispatch(businessUser.delete({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/platform-management/business-users/delete`,
          entity: 'businessUser',
          jsonData: {
            Records: [
              {
             
                    Id: data?.Id
                }
              
            ]
          }
      })).then(() => {
        dispatch(businessUser.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/platform-management/business-users/list`,entity:'businessUser',jsonData:{
      
          "Records": [
            {
              "Context": {
              },
              "Message": {}
            }
          ],
          "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "Id",
                    "SortOrder": "desc",
                   
          }
        
    
        }}))
      });
      }
	return (
    <>
    {businessItems?.isLoading ?  <PageLoader />: 
		<Table enableFilter={true} additionButtons={additionButtons}
    filterTypeLists={filterTypes}
    onSearch={handleSearch} columnData={columnDefs} rowData={businessItems?.result?.items} setPageData={setPageData}
    setPageSize={setPageSize} paginationData={businessItems?.result?.pagination}  onDelete={handleDelete}  headingName="Business Users"/>
     
  }
  </> 
	);
};

export default BusinessUsers;


